const PREFIX = '/';

export const ROUTE_LANDING = PREFIX + '';
export const ROUTE_WELCOME = PREFIX + 'welcome';
export const ROUTE_HOME = PREFIX + 'home';
export const ROUTE_PRIVACY_AND_TERMS_OF_USE = PREFIX + 'privacy_and_terms_of_use';
export const ROUTE_PAYMENT = PREFIX + 'payment';


export const ROUTE_ERROR_CGN = PREFIX + 'errors/cgn';

// ROUTES FROM CONFIG_SLIM
export const ROUTE_STEP_FULL_NAME = PREFIX + 'steps/full_name';
export const ROUTE_STEP_LEAD = PREFIX + 'steps/lead';
export const ROUTE_STEP_BIRTHDAY = PREFIX + 'steps/birthday';
export const ROUTE_STEP_LAST_TITLE = PREFIX + 'steps/latest_title';
export const ROUTE_STEP_IS_KNOW_WHAT_STUDY = PREFIX + 'steps/is_know_what_study';
export const ROUTE_STEP_INTERESTS_OPEN = PREFIX + 'steps/interests_open';
export const ROUTE_STEP_FUTURE_STEP_WORK_OPEN = PREFIX + 'steps/future_step_work_open';
export const ROUTE_STEP_STUDY_AREA = PREFIX + 'steps/study_area';
export const ROUTE_STEP_STUDY_WHERE_HS = PREFIX + 'steps/study_where_hs';
export const ROUTE_STEP_STUDY_WHERE_NOT_HS = PREFIX + 'steps/study_where_not_hs';

export const ROUTE_STEP_EMAIL = PREFIX + 'steps/email';
export const ROUTE_STEP_DOMICILE = PREFIX + 'steps/domicile';
export const ROUTE_STEP_ITALIAN_RESIDENCE = PREFIX + 'steps/italian_residence';
export const ROUTE_STEP_IS_HS_DONE = PREFIX + 'steps/is_hs_done';
export const ROUTE_STEP_HS_SCHOOL_ENROLLED = PREFIX + 'steps/hs_school_enrolled';
export const ROUTE_STEP_HS_SCHOOL_COURSE_TYPE_ENROLLED = PREFIX + 'steps/hs_school_course_type_enrolled';
export const ROUTE_STEP_HS_YEAR_AT = PREFIX + 'steps/hs_year_at';
export const ROUTE_STEP_HS_SCHOOL = PREFIX + 'steps/hs_school';
export const ROUTE_STEP_HS_SCHOOL_COURSE_TYPE = PREFIX + 'steps/hs_school_course_type';
export const ROUTE_STEP_HS_SCHOOL_GRADUATION_YEAR = PREFIX + 'steps/hs_school_graduation_year';
export const ROUTE_STEP_HS_SCHOOL_GRADE = PREFIX + 'steps/hs_school_grade';
export const ROUTE_STEP_HAS_POST_HS_TITLES = PREFIX + 'steps/has_post_hs_titles';

export const ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_COMPLETED = PREFIX + 'steps/post_hs_school_title_type_completed';
export const ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_COMPLETED = PREFIX + 'steps/post_hs_school_title_school_completed';
export const ROUTE_STEP_POST_HS_SCHOOL_COURSE_COMPLETED = PREFIX + 'steps/post_hs_school_course_completed';
export const ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_COMPLETED = PREFIX + 'steps/post_hs_school_year_at_completed';
export const ROUTE_STEP_POST_HS_SCHOOL_GRADE_COMPLETED = PREFIX + 'steps/post_hs_school_grade_completed';

export const ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL = PREFIX + 'steps/is_enrolled_post_hs_school';

export const ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_ENROLLED = PREFIX + 'steps/post_hs_school_title_type_enrolled';
export const ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_ENROLLED = PREFIX + 'steps/post_hs_school_title_school_enrolled';
export const ROUTE_STEP_POST_HS_SCHOOL_COURSE_ENROLLED = PREFIX + 'steps/post_hs_school_course_enrolled';
export const ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED = PREFIX + 'steps/post_hs_school_year_at_enrolled';

export const ROUTE_STEP_SUB_INTERESTS = PREFIX + 'steps/sub_interests';
export const ROUTE_STEP_FUTURE_STEP_WORK = PREFIX + 'steps/future_step_work';
export const ROUTE_STEP_FUTURE_STEP_SCHOOL_TYPE = PREFIX + 'steps/future_step_school_type';
export const ROUTE_STEP_FUTURE_STEP_WHERE = PREFIX + 'steps/future_step_where';

export const ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL_FALSE_SURVEY = PREFIX + 'steps/surveys/is_enrolled_post_hs_school_false_survey';
export const ROUTE_STEP_FUTURE_STEP_WHERE_SURVEY = PREFIX + 'steps/surveys/future_step_where_survey';
export const ROUTE_STEP_HS_YEAR_AT_SURVEY = PREFIX + 'steps/surveys/hs_year_at_survey';
export const ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED_SURVEY = PREFIX + 'steps/surveys/post_hs_school_year_at_enrolled_survey';

export const ROUTE_ADVISORY_FULL_STEP_LIST_FULL = PREFIX + 'advisory_full/step_list_full';
export const ROUTE_ADVISORY_FULL_STEP_HOME_FULL = PREFIX + 'advisory_full/step_home_full';
export const ROUTE_ADVISORY_FULL_STEP_HOME_FULL_SURVEY = PREFIX + 'advisory_full/surveys/step_home_full_survey';

export const ROUTE_ADVISORY_FINANCIAL_STEP_HOME_FINANCIAL = PREFIX + 'advisory_financial/step_home_financial';
export const ROUTE_ADVISORY_FINANCIAL_STEP_CHART = PREFIX + 'advisory_financial/step_chart';
export const ROUTE_ADVISORY_FINANCIAL_STEP_CHART_SURVEY = PREFIX + 'advisory_financial/surveys/step_chart_survey';

export const ROUTE_THANK_YOU = PREFIX + 'advisory_financial/thank_you';

export const routes: Record<string, string> = {
    'ROUTE_PAYMENT': ROUTE_PAYMENT,
    'ROUTE_LANDING': ROUTE_LANDING,
    'ROUTE_WELCOME': ROUTE_WELCOME,
    'ROUTE_HOME': ROUTE_HOME,
    'ROUTE_STEP_FULL_NAME': ROUTE_STEP_FULL_NAME,
    'ROUTE_STEP_LAST_TITLE': ROUTE_STEP_LAST_TITLE,
    'ROUTE_STEP_IS_KNOW_WHAT_STUDY': ROUTE_STEP_IS_KNOW_WHAT_STUDY,
    'ROUTE_STEP_INTERESTS_OPEN': ROUTE_STEP_INTERESTS_OPEN,
    'ROUTE_STEP_FUTURE_STEP_WORK_OPEN': ROUTE_STEP_FUTURE_STEP_WORK_OPEN,
    'ROUTE_STEP_STUDY_AREA': ROUTE_STEP_STUDY_AREA,
    'ROUTE_STEP_STUDY_WHERE_HS': ROUTE_STEP_STUDY_WHERE_HS,
    'ROUTE_STEP_STUDY_WHERE_NOT_HS': ROUTE_STEP_STUDY_WHERE_NOT_HS,
    'ROUTE_STEP_LEAD': ROUTE_STEP_LEAD,
    'ROUTE_STEP_BIRTHDAY': ROUTE_STEP_BIRTHDAY,
    'ROUTE_STEP_EMAIL': ROUTE_STEP_EMAIL,
    'ROUTE_STEP_DOMICILE': ROUTE_STEP_DOMICILE,
    'ROUTE_STEP_ITALIAN_RESIDENCE': ROUTE_STEP_ITALIAN_RESIDENCE,
    'ROUTE_STEP_IS_HS_DONE': ROUTE_STEP_IS_HS_DONE,
    'ROUTE_STEP_HS_SCHOOL_ENROLLED': ROUTE_STEP_HS_SCHOOL_ENROLLED,
    'ROUTE_STEP_HS_SCHOOL_COURSE_TYPE_ENROLLED': ROUTE_STEP_HS_SCHOOL_COURSE_TYPE_ENROLLED,
    'ROUTE_STEP_HS_YEAR_AT': ROUTE_STEP_HS_YEAR_AT,
    'ROUTE_STEP_HS_SCHOOL': ROUTE_STEP_HS_SCHOOL,
    'ROUTE_STEP_HS_SCHOOL_COURSE_TYPE': ROUTE_STEP_HS_SCHOOL_COURSE_TYPE,
    'ROUTE_STEP_HS_SCHOOL_GRADUATION_YEAR': ROUTE_STEP_HS_SCHOOL_GRADUATION_YEAR,
    'ROUTE_STEP_HS_SCHOOL_GRADE': ROUTE_STEP_HS_SCHOOL_GRADE,
    'ROUTE_STEP_HAS_POST_HS_TITLES': ROUTE_STEP_HAS_POST_HS_TITLES,

    'ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_COMPLETED': ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_COMPLETED,
    'ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_COMPLETED': ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_COMPLETED,
    'ROUTE_STEP_POST_HS_SCHOOL_COURSE_COMPLETED': ROUTE_STEP_POST_HS_SCHOOL_COURSE_COMPLETED,
    'ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_COMPLETED': ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_COMPLETED,
    'ROUTE_STEP_POST_HS_SCHOOL_GRADE_COMPLETED': ROUTE_STEP_POST_HS_SCHOOL_GRADE_COMPLETED,

    'ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL': ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL,

    'ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_ENROLLED': ROUTE_STEP_POST_HS_SCHOOL_TITLE_TYPE_ENROLLED,
    'ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_ENROLLED': ROUTE_STEP_POST_HS_SCHOOL_TITLE_SCHOOL_ENROLLED,
    'ROUTE_STEP_POST_HS_SCHOOL_COURSE_ENROLLED': ROUTE_STEP_POST_HS_SCHOOL_COURSE_ENROLLED,
    'ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED': ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED,


    'ROUTE_STEP_SUB_INTERESTS': ROUTE_STEP_SUB_INTERESTS,
    'ROUTE_STEP_FUTURE_STEP_WORK': ROUTE_STEP_FUTURE_STEP_WORK,
    'ROUTE_STEP_FUTURE_STEP_SCHOOL_TYPE': ROUTE_STEP_FUTURE_STEP_SCHOOL_TYPE,
    'ROUTE_STEP_FUTURE_STEP_WHERE': ROUTE_STEP_FUTURE_STEP_WHERE,

    'ROUTE_ADVISORY_FULL_STEP_LIST_FULL': ROUTE_ADVISORY_FULL_STEP_LIST_FULL,
    'ROUTE_ADVISORY_FULL_STEP_HOME_FULL': ROUTE_ADVISORY_FULL_STEP_HOME_FULL,
    'ROUTE_ADVISORY_FINANCIAL_STEP_HOME_FINANCIAL': ROUTE_ADVISORY_FINANCIAL_STEP_HOME_FINANCIAL,
    'ROUTE_ADVISORY_FINANCIAL_STEP_CHART': ROUTE_ADVISORY_FINANCIAL_STEP_CHART,

    'ROUTE_THANK_YOU': ROUTE_THANK_YOU,

    'ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL_FALSE_SURVEY': ROUTE_STEP_IS_ENROLLED_POST_HS_SCHOOL_FALSE_SURVEY,
    'ROUTE_STEP_FUTURE_STEP_WHERE_SURVEY': ROUTE_STEP_FUTURE_STEP_WHERE_SURVEY,
    'ROUTE_STEP_HS_YEAR_AT_SURVEY': ROUTE_STEP_HS_YEAR_AT_SURVEY,
    'ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED_SURVEY': ROUTE_STEP_POST_HS_SCHOOL_YEAR_AT_ENROLLED_SURVEY,
    'ROUTE_ADVISORY_FULL_STEP_HOME_FULL_SURVEY': ROUTE_ADVISORY_FULL_STEP_HOME_FULL_SURVEY,
    'ROUTE_ADVISORY_FINANCIAL_STEP_CHART_SURVEY': ROUTE_ADVISORY_FINANCIAL_STEP_CHART_SURVEY,
}